export const MenuItems = [

    {   type: 1,
        title: "Description",
        path: "./description",
        cName: "dropdown-link"
    },
    {
        type: 1,
        title: "Contribution",
        path: "./contribution",
        cName: "dropdown-link"
    },
    {
        type: 1,
        title: "UN SDGs",
        path: "./sustainable",
        cName: "dropdown-link"
    },
    {
        type: 1,
        title: "Implementation",
        path: "./implementation",
        cName: "dropdown-link"
    },
    {
        type: 2,
        title: "Engineering",
        path: "./engineering",
        cName: "dropdown-link"
    },
    {
        type: 2,
        title: "Results",
        path: "./results",
        cName: "dropdown-link"
    },
    {
        type: 2,
        title: "Proof of Concept",
        path: "./proof-of-concept",
        cName: "dropdown-link"
    },
    //     type: 2,
    //     title: "Parts",
    //     path: "./parts",
    //     cName: "dropdown-link"
    // },
    {
        type: 3,
        title: "Model",
        path: "./model",
        cName: "dropdown-link"
    },
    {
        type: 3,
        title: "Hardware",
        path: "./hardware",
        cName: "dropdown-link"
    },
    {
        type: 4,
        title: "Integrated Human Practices",
        path: "./human-practices",
        cName: "dropdown-link"
    },
    {
        type: 4,
        title: "Education",
        path: "./education",
        cName: "dropdown-link"
    },
    {
        type: 4,
        title: "Inclusivity",
        path: "./inclusivity",
        cName: "dropdown-link"
    },
    {
        type: 4,
        title: "Education & Communication",
        path: "./communication",
        cName: "dropdown-link"
    },
    {
        type: 4,
        title: "Sponsors",
        path: "./sponsors",
        cName: "dropdown-link"
    },
    {   
        type: 5,
        title: "Our People",
        path: "./people",
        cName: "dropdown-link"
    },    
    {   
        type: 5,
        title: "Collaborations",
        path: "./collaborations",
        cName: "dropdown-link"
    },
    {
        type: 5,
        title: "Attributions",
        path: "./attributions",
        cName: "dropdown-link"
    },
]